










































































































































































































































































































import Vue from 'vue'
import { mapGetters } from 'vuex'
import { parseMap, isDisplayShow } from '@/utils/index'
import {
  ProductionPlanServiceProxy,
  ProductionOrderServiceProxy,
  ProductionPlan,
  ProductionPlanTypeProductTypeServiceProxy
} from '@/service-proxies/app-v2/coproduction.service-proxies'
import EditOrAddPlan from './components/AddOrEditPlan.vue'
import DistributePlan from './components/DistributePlan.vue'
import { planStatusMap, planStatusMapColor, planCategoryMap } from '@/utils/commonDef'
import CompleteOrClosePlan from './components/CompleteOrClosePlan.vue'
import PlanSetting from './components/PlanSetting'
import dayjs from 'dayjs'
import './index.less'
import { TenantBizFieldServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import AdvancedSearch from '@/components/AdvancedSearch'
import ImportButton from './components/ImportButton.vue'
import ExportDropdown from './components/ExportDropdown.vue'
import CodeModel from '@/components/CodeModel/index.vue'
import { exportProductionPlan } from '@/api/api'
import { cloneDeep } from 'lodash'
import BlankView from '@/layout/BlankView.vue'
import { setLocalStorage } from '@/utils/storage'
const productionPlanServiceProxy = new ProductionPlanServiceProxy()
const tenantBizFieldServiceProxy = new TenantBizFieldServiceProxy()
const productionPlanTypeProductTypeServiceProxy = new ProductionPlanTypeProductTypeServiceProxy()
const productionOrderServiceProxy = new ProductionOrderServiceProxy()

export default Vue.extend({
  name: '',
  components: {
    EditOrAddPlan,
    DistributePlan,
    CompleteOrClosePlan,
    PlanSetting,
    AdvancedSearch,
    ImportButton,
    ExportDropdown,
    CodeModel,
    BlankView
  },
  data() {
    return {
      data: [],
      loading: false,
      pageSize: 30,
      currentPage: 1,
      visible: false,
      searchDto: {
        typeId: this.$route.path[this.$route.path.length - 1],
        filterPlus: false,
        planStatus: ['1', '2', '3', '4'],
        param: {}
      },
      planStatusMap,
      planStatusMapColor,
      planStatusList: parseMap(planStatusMap),
      selectedRowKeys: [],
      currentPlan: null,
      // 当前选择的行的顺序
      selectedRowIndex: -1,
      customRow: (record) => {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self: any = this
        return {
          on: {
            click: (e) => {
              self.currentPlan = { ...record }
              self.selectedRowKeys = [self.currentPlan.id]
              self.selectedRowIndex = self.data.findIndex((res) => res.id === record.id)
            }
          }
        }
      },
      planCategoryMap,
      formData: {},
      totalContent: 0, // 表格总数
      distributeModal: 0, // 派发模式
      distributeVisible: false, // 派发
      addFlag: false,
      showCompleteOrClosePlan: false,
      isCompletePlan: false,
      productColums: [], // 产品表格的字段
      showColumns: [],
      tableScrollWidth: 1700,
      tableScrollHeight: 330,
      resizeTimer: null,
      bodyTableBody: null,
      workOrderTableBody: null,
      showPrint: false,
      dataList: [],
      productTypeList: [],
      productTypeId: '',
      inputVisible: false
    }
  },
  created() {
    this.getProductType()
    this.getTableColumn()
    this.load(true)
  },
  computed: {
    ...mapGetters(['buttons']),
    exportFn() {
      const data = {
        exportSelected: false,
        searchCondition: this.searchDto,
        selectedRecords: [],
        typeId: this.searchDto.typeId
      }
      return exportProductionPlan.bind(this, data)
    },
    rowSelection() {
      const { selectedRowKeys }: any = this
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys: [], selectedRows: []) => {
          this.selectedRowKeys = selectedRowKeys
          if (this.selectedRowKeys.length === 1) {
            this.selectedRowIndex = this.data.findIndex((res) => res.id === this.selectedRowKeys[0])
            this.currentPlan = this.data.find((res) => res.id === this.selectedRowKeys[0]) || {}
          }
        },
        getCheckboxProps(record) {
          return ({
            style: {
              display: record.id ? 'block' : 'none'
            },
            props: {
              disabled: record.id ? false : true
            }
          })
        }
      }
    },
    hasSelected() {
      return this.selectedRowKeys.length > 0
    },
    onlySelectedOne() {
      return this.selectedRowKeys.length === 1
    },
    buttonStatus() {
      // 判断按钮是否可点状态
      if (!this.onlySelectedOne) {
        return false
      }
      const chooseData: ProductionPlan = this.data.find((res) => res.id === this.selectedRowKeys[0])
      if (!chooseData) {
        return false
      }
      return {
        edit:
          chooseData.planStatus === 1 || chooseData.planStatus === 2 || chooseData.planStatus === 3,
        assign:
          (chooseData.planStatus === 1 ||
            chooseData.planStatus === 2 ||
            chooseData.planStatus === 3) &&
          chooseData.unassignedNum > 0,
        stop:
          chooseData.planStatus === 1 || chooseData.planStatus === 2 || chooseData.planStatus === 3,
        add: chooseData.planStatus === 2 || chooseData.planStatus === 3,
        restart: chooseData.planStatus === 4,
        finish: chooseData.planStatus === 3 || chooseData.planStatus === 4,
        close: chooseData.planStatus === 3 || chooseData.planStatus === 4
      }
    },
    delButtonStatus() {
      let flag = true
      if (!this.hasSelected) {
        return false
      }
      const chooseDataList = []
      this.data.forEach((res) => {
        this.selectedRowKeys.forEach((rowKey) => {
          if (res.id === rowKey) {
            chooseDataList.push(res)
          }
        })
      })
      if (chooseDataList.length === 0) {
        return false
      }
      chooseDataList.forEach((res) => {
        if (res.planStatus !== 1) {
          flag = false
        }
      })
      return flag
    },
    tabKeys() {
      const showTabKeys = [this.$t('page_work_order')]
      const tabKeys = [
        'page_plan_material_requirement_list',
        'page_plan_material_consume',
        'page_plan_wip_delivery_statistics',
        'page_plan_wip_warehousing_statistics'
      ]
      tabKeys.map((res) => {
        if (this.buttons.includes(res + '_' + this.searchDto.typeId)) {
          showTabKeys.push(this.$t(res))
        }
      })
      return showTabKeys
    }
  },
  watch: {
    'searchDto.planStatus'() {
      this.getTableList()
    }
  },
  updated() {
    this.tableScrollHeight = document.querySelector('#black-main').clientHeight
  },
  beforeDestroy() {
    clearTimeout(this.resizeTimer)
  },
  methods: {
    cancelChooseArr(val) {
      this.selectedRowKeys = [];
    },
    // flag 为true 第一次下单
    //是否为新建
    dayjs(time) {
      return dayjs(time).format('YYYY-MM-DD')
    },
    openViewJob(record) {
      const job = {
        id: record.id,
        code: record.code
      }
      setLocalStorage('jobInfo', job)
      this.$router.push('/job/plan/production-order-process/' + this.searchDto.typeId)
    },
    showStatusColor(value) {
      const status = this.searchDto.planStatus.find((res) => res == value)
      let color = ''
      if (status) {
        color = this.planStatusMapColor[value]
      }
      return color
    },
    inSearchStatus(value) {
      const status = this.searchDto.planStatus.find((res) => res == value)
      let boolean = false
      if (status) {
        boolean = true
      }
      return boolean
    },
    inputStatus(value) {
      const newTags = [...this.searchDto.planStatus]
      const status = this.searchDto.planStatus.find((res) => res == value)
      if (!status) {
        this.searchDto.planStatus.push(value)
      } else {
        this.searchDto.planStatus = newTags.filter((res) => res != value)
      }
    },
    getTableList(flag, isNew) {
      this.selectedRowKeys = []
      this.loading = true
      productionPlanServiceProxy
        .page(this.currentPage, this.searchDto, this.pageSize)
        .then((res) => {
          this.loading = false
          if (res.records.length > 0) {
            if (isNew) {
              this.currentPlan = res.records[0]
              this.selectedRowIndex = 0
            } else if (this.currentPlan) {
              const planIndex = res.records.findIndex((res) => res.id === this.currentPlan.id)
              if (planIndex > -1) {
                this.currentPlan = res.records[planIndex]
                this.selectedRowIndex = planIndex
              } else {
                this.currentPlan = res.records[0]
                this.selectedRowIndex = 0
              }
            } else if (!flag) {
              this.currentPlan = res.records[0]
              this.selectedRowIndex = 0
            }
            if (this.currentPlan) {
              this.selectedRowKeys = [this.currentPlan.id]
            }
            this.totalContent = res.total
            res.records.forEach((resX: any) => {
              if(resX.id) {
                resX.planEndTime = this.covertTime(resX.planEndTime)
                resX.planStartTime = this.covertTime(resX.planStartTime)
                resX.startTime = this.covertTime(resX.startTime)
                resX.endTime = this.covertTime(resX.endTime)
                resX.updateTime = this.covertTime(resX.updateTime)
                resX.createTime = this.covertTime(resX.createTime)
              }
            })
            this.data = res.records



          } else {
            this.totalContent = 0
            this.data = []
          }

          let dataLength = res.records.length;
          let copy = res.records
          let needPush = 0;
          if(dataLength < 30) {
            needPush = 30 - dataLength;
            for(var k=0; k<needPush; k++) {
              let obj:any = {
                // id: 'none'
              }
              copy.push(obj)
            }
          }
          this.data = copy;
          console.log(this.data,'this.data')


        })
    },
    load(flag, isNew) {
      // this.getTableColumn()
      this.selectedRowKeys = []
      this.loading = true
      productionPlanServiceProxy
        .page(this.currentPage, this.searchDto, this.pageSize)
        .then((res) => {
          this.loading = false
          if (res.records.length > 0) {
            if (isNew) {
              this.currentPlan = res.records[0]
              this.selectedRowIndex = 0
            } else if (this.currentPlan) {
              const planIndex = res.records.findIndex((res) => res.id === this.currentPlan.id)
              if (planIndex > -1) {
                this.currentPlan = res.records[planIndex]
                this.selectedRowIndex = planIndex
              } else {
                this.currentPlan = res.records[0]
                this.selectedRowIndex = 0
              }
            } else if (!flag) {
              this.currentPlan = res.records[0]
              this.selectedRowIndex = 0
            }
            if (this.currentPlan) {
              this.selectedRowKeys = [this.currentPlan.id]
            }
            this.totalContent = res.total
            res.records.forEach((resX: any) => {
              if(resX.id) {
                resX.planEndTime = this.covertTime(resX.planEndTime)
                resX.planStartTime = this.covertTime(resX.planStartTime)
                resX.startTime = this.covertTime(resX.startTime)
                resX.endTime = this.covertTime(resX.endTime)
                resX.updateTime = this.covertTime(resX.updateTime)
                resX.createTime = this.covertTime(resX.createTime)
              }
            })
            this.data = res.records
          } else {
            this.totalContent = 0
            this.data = []
          }

          let dataLength = res.records.length;
          let copy = res.records;
          let needPush = 0;
          if(dataLength < 30) {
            needPush = 30 - dataLength;
            for(var k=0; k<needPush; k++) {
              let obj:any = {
                // id: 'none'
              }
              copy.push(obj)
            }
          }
          this.data = copy;
          console.log(this.data,'this.data')

        })
    },
    async getProductType() {
      let temp = []
      const res = await productionPlanTypeProductTypeServiceProxy.getProductTypeList(
        this.searchDto.typeId
      )
      temp = res.map((item) => ({ label: item.name, value: item.id }))
      this.productTypeList = temp
    },
    reload(data) {
      /*let keys: any = Object.keys(data)
      let removeIndex = keys.findIndex(item => item === 'code_like')
      keys.splice(removeIndex, 1)
      keys.push('code_equal')
      let params = {}
      keys.map(k => {
        if (k === 'code_equal')
          params[k] = data.code_like
        else
          params[k] = data[k]
      })*/
      // this.productTypeList.map(item => {
      //   if(item.label === data.product_type_name_like)
      //   data["product_type_name_like"] = item.value
      // })
      this.searchDto.filterPlus = true
      this.searchDto.param = data
      this.currentPage = 1
      this.$nextTick(() => this.load())
    },

    // flag 是否需要更新列表
    // isNew是否为新建完成
    // 如果有id直接查详情在打开 直接编辑
    closeModal(flag, isNew, id) {
      this.visible = false
      if (flag) {
        if (isNew) {
          this.currentPage = 1
        }
        this.load(false, isNew)
      }
      if (id) {
        productionPlanServiceProxy.detail(id).then((res) => {
          this.formData = res
          this.visible = true
        })
      }
    },
    deletePlan() {
      productionPlanServiceProxy.delete(this.selectedRowKeys).then((res) => {
        this.$message.info(this.$t('page_user_management_delete_succeeded'))
        this.currentPage = 1
        this.load()
      })
    },
    // flag为true 是编辑, addFlag是否为追加
    openModal(flag, addFlag) {
      this.visible = true
      this.addFlag = !!addFlag
      if (flag) {
        this.data.forEach((res) => {
          if (res.id === this.selectedRowKeys[0]) {
            this.formData = cloneDeep(res)
          }
        })
      } else {
        this.formData = {}
      }
    },
    // flag为true 是编辑, addFlag是否为追加
    openEditModal(record) {
      this.addFlag = false
      this.visible = true
      const formData = this.data.find((res) => res.id == record.id)
      if (formData) {
        this.formData = formData
      } else {
        this.formData = {}
      }
    },
    openSetting() {
      this.$refs.planSetting.openModal()
    },
    closeSetting() {
      this.load()
      this.getProductType()
    },
    //转换时间
    covertTime(time) {

      if(time == undefined) {
        return ''
      }
      else if(time == null) {
        return ''
      }
      // else if(time == null ) {
      //   return ''
      // }
      // else {
      //   console.log(time,'aaaaaaaaaaaaa')
      //   return dayjs(time).format('YYYY-MM-DD')
      // }
      else if (time) {
        return dayjs(time).format('YYYY-MM-DD')
      }
      // return ''
    },
    pageIndexchange(currentPage) {
      this.currentPage = currentPage
      this.load()
    },

    assign(value) {
      this.distributeModal = value
      this.distributeVisible = true
    },
    closeassign(value) {
      this.distributeVisible = false
      if (value) {
        this.$message.info(this.$t('page_resource_pool_success'))
        this.load()
      }
    },
    stop() {
      productionPlanServiceProxy.pausePlan(this.selectedRowKeys[0]).then((res) => {
        this.$message.info(this.$t('page_resource_pool_success'))
        this.load()
      })
    },
    restart() {
      productionPlanServiceProxy.restartPlan(this.selectedRowKeys[0]).then((res) => {
        this.$message.info(this.$t('page_resource_pool_success'))
        this.load()
      })
    },
    finishOrClose(flag) {
      this.isCompletePlan = flag
      this.showCompleteOrClosePlan = true
    },
    getDataList() {
      this.dataList = []
      this.selectedRowKeys.map((id) => {
        this.data.map((item) => {
          if (id === item.id) {
            this.dataList.push({
              code: item.code,
              name: item.productName
            })
          }
        })
      })
    },
    printing() {
      this.getDataList()
      this.showPrint = true
    },
    cancel() {
      this.selectedRowKeys = []
      this.showPrint = false
    },
    handlerPrint() {
      this.selectedRowKeys = []
      this.showPrint = false
    },
    totalFanyi(number: any) {
      const total = this.$t('Total…items')
      return total.replace('{0}', number)
    },
    closeCompleteModal(flag) {
      this.showCompleteOrClosePlan = false
      if (flag) {
        this.$message.info(this.$t('page_resource_pool_success'))
        this.load()
      }
    },
    // 获取指定业务的字段列表
    async getTableColumn() {
      this.productColums = []
      this.productColums = await tenantBizFieldServiceProxy.getTenantBizField(
        'plan',
        this.searchDto.typeId
      )
      this.handleColumns()
    },
    covertLang(obj) {
      for (const key in obj) {
        obj[key] = this.$t(obj[key])
      }
    },
    handleColumns() {
      this.showColumns = []
      if (!this.productColums || !this.productColums.length) {
        return
      }
      // 字段排序
      this.productColums.sort((a, b) => {
        return a.sort - b.sort
      })
      // 字段显隐
      let columns = [
        {
          title: this.$t('actions'),
          key: 'action',
          width: 160,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ]
      const scopedSlots = ['planStatus', 'category', ]
      const scopedSlotTimes = ["planStartTime", "planEndTime"]
      // this.productColums.map(item => {
      //   if(item.code === "productTypeName"){
      //     item.isDisplay = 7
      //   }
      // })
      this.productColums.map((item) => {
        if (isDisplayShow(item.isDisplay, 2)) {
          // 自定义字段：产品类型
          const temp: any = {
            title: item.title,
            key: item.code,
            dataIndex: item.code,
            ellipsis: true
          }
          temp.width = (temp.title.length + 1) * 20
          if (scopedSlots.includes(temp.key)) {
            temp.scopedSlots = { customRender: temp.key }
          }
          if(scopedSlotTimes.includes(temp.key)) {
            temp.scopedSlots = { customRender: temp.key }
          }
          columns.push(temp)
        }
      })
      this.showColumns = [...columns]
      let num = this.productColums.filter((item) => isDisplayShow(item.isDisplay, 2)).length
      this.tableScrollWidth = num * 100
    },
    afterImport() {
      this.load()
    },
    async alllAssign() {
      let planIds = this.selectedRowKeys.toString()
      console.log(planIds,9999)
      await productionOrderServiceProxy.assignPlanBatch(planIds).then(res =>{
        this.$message.info(res)
        this.load()
      })
    }
  }
})
